import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import AddCustomer from "./components/addCustomer";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import AdvanceTable from "../../components/advanceTable";
import { SearchTypeEnum } from "../../constants/appConstant";

const ClubCustomers = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  // const [pageSize, setPageSize] = useState(null);
  const [customerId, setCustomerId] = useState();

  useEffect(() => {
    getData(1);
  }, []);

  useEffect(() => {
    if (!open) {
      setCustomerId();
    }
  }, [open]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    debugger;
    const response = await Common.ApiService.getInstance().request(
      "ClubPlayers",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        recordsToDisplay,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          phone: `${item.phoneCode ?? ""}-${item.phone ?? ""}`,
          email: item.email ?? "-",
          cnic: item.cnic ?? "-",
          isExternal: item.isExternal, // Ensure isExternal is preserved
        })),
      };

      console.log("Processed data:", obj.data); // Debug log
      setData(obj);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const renderCustomerType = (item) => (
    <div
      className="flex items-center gap-2"
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      <span className="text-lg">{item.isExternal ? "🌐" : "🏠"}</span>
      <span
        className={`text-sm font-medium ${
          item.isExternal ? "text-blue-600" : "text-green-600"
        }`}
      >
        {item.isExternal ? "External" : "Internal"}
      </span>
    </div>
  );

  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        console.log("Edit clicked for:", val);
        global.log("val", val);
        setOpen(true);
        setCustomerId(val.id);
      },
      visibleProp: "isExternal",
      visibleValue: 0,
    },
  ];

  let columns = [
    { title: "First Name", type: "text", key: "firstName", isVisible: true },
    { title: "Last Name", type: "text", key: "lastName", isVisible: true },
    { title: "Email", type: "text", key: "email", isVisible: true },
    { title: "Phone #", type: "text", key: "phone", isVisible: true },
    { title: "CNIC #", type: "text", key: "cnic", isVisible: true },
    // {
    //   title: "Customer Type",
    //   type: "text",
    //   key: "customerType",
    //   isVisible: false,
    //   render: renderCustomerType,
    // },
  ];

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Customers"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddCustomer
              id={customerId}
              onClose={(val) => getData()}
              open={open}
              setOpen={setOpen}
              bookingModal={false}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile"
          showExportoptions
          exportFileName={"customers"}
          // displayCount={pageSize}
        />
      )}
    </>
  );
};

export default ClubCustomers;
